import { render, staticRenderFns } from "./receipt-processor.vue?vue&type=template&id=2c8ba280&scoped=true"
import script from "./receipt-processor.vue?vue&type=script&lang=js"
export * from "./receipt-processor.vue?vue&type=script&lang=js"
import style0 from "./receipt-processor.vue?vue&type=style&index=0&id=2c8ba280&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8ba280",
  null
  
)

export default component.exports